export default {
  // ------共用------
  Shared: {
    Prompt: 'Prompt',
    requestLoadFailed: 'Failed to load. Please try again later!',
    requestErrorCode: 'Error code: {code}',
    requestTraceId: 'Trace ID: ',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Close: 'Close',
    isTurnOn: 'Enable',
    Save: 'Save',
    Submit: 'Submit',
    Return: 'Back',
    info: 'Refresh',
    del: 'Delete',
    Reset: 'Reset',
    Query: 'Search',
    Filter: 'Filter',
    addFilter: 'Add Filter',
    noMoreFilters: 'No more filters',
    success: 'Operation successful',
    editMessage: 'Updated successfully',
    pleaseEnter: 'Please enter',
    pleaseChoose: 'Please select',
    Male: '男',
    Female: '女',
    Unknown: 'Unknown',
    Operation: 'Actions',
    NextStep: 'Next',
    PreStep: '上一步',
    Clear: 'Clear',
    Selected: '已选择',
    Disabled: 'Disabled',
    Enable: 'Enabled',
    edit: 'Edit',
    status: '状态',
    Creator: '创建人',
    UpdatedBy: '更新人',
    CreationTime: '创建时间',
    periodValidity: '有效期',
    Loading: '加载中...',
    loaded: '已加载全部数据',
    BatchOperation: '批量操作',
    maxSelected: '最多选择',
    Insert: '插入',
    Sort: '排序',
  },
  editorToolbar: {
    undo: 'Undo',
    redo: 'Redo',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strike: 'Strikethrough',
    blockquote: 'Blockquote',
    codeBlock: 'Code Block',
    orderedList: 'Ordered List',
    bulletList: 'Bullet List',
    decreaseIndent: 'Decrease Indent',
    increaseIndent: 'Increase Indent',
    fontSize: 'Font Size',
    heading: 'Heading',
    textColor: 'Text Color',
    backgroundColor: 'Background Color',
    alignment: 'Alignment',
    clearFormat: 'Clear Formatting',
    link: 'Insert Link',
    image: 'Insert Image',
    video: 'Insert Video',
  },
  form: {
    StartDate: '开始日期',
    EndDate: '结束日期',
  },
  Unit: {
    zhang: '张',
    millisecond: 'ms',
    yuan: '',
  },

  // 路由国际化
  route: {
    dashboard: '首页',
    document: '项目文档',
  },
  // 登录页面国际化
  login: {
    selectPlaceholder: 'Select or enter a company name',
    welcome: 'Welcome to Zhijie',
    account: 'Account',
    username: 'Username',
    password: 'Password',
    showPassword: 'Show',
    hidePassword: 'Hide',
    phoneNumber: 'Phone',
    smsCode: 'SMS code',
    login: 'Log in',
    logging: 'Logging in...',
    code: 'Verification code',
    passwordLogin: 'Password',
    phoneLogin: 'Phone',
    rememberAccount: 'Remember account',
    rememberPassword: 'Remember me',
    forgotPassword: 'Forgot password?',
    sendCode: 'Send code',
    resendAfter: 'Resend in {seconds}s',
    smsSent: 'Verification code sent',
    agreementPrefix: 'I have read and agree to the',
    serviceAgreement: '《Zhiqu Terms of Service》',
    agreementAnd: 'and',
    privacyPolicy: '《Zhiqu Privacy Policy》',
    collectionList: 'Zhiqu Personal Information Collection List',
    backToLogin: 'Back to login',
    chinese: '中文',
    english: 'English',
    agreementRequired: 'Please agree to the Terms of Service and Privacy Policy first',
    agreementConfirmTitle: 'Terms and Privacy Policy',
    agreementConfirmPrefix: 'Please read and agree to',
    agreementConfirmSuffix: 'before continuing to log in.',
    agreementConfirmMessage: 'Please read and agree to the Terms of Service and Privacy Policy before logging in.',
    agreeAndLogin: 'Agree and Log In',
    contactAdmin: 'Please contact the administrator for more information',
    downloadApp: 'Download Zhijie App',
    switchRegisterPage: 'Register now',
    title: 'Welcome!',
    logoutTitle: 'Are you sure you want to log out?',
    accountLogin: 'Account Login',
    qrCodeLogin: 'Scan to Log In',
    qrLoginTitle: 'Scan to Log In',
    qrCodeTip: 'Scan the QR code with the Zhijie App to log in',
    qrValidFor: 'QR code valid for: {seconds}s',
    qrCodePosterAlt: 'Arcade promotion poster',
    qrCodeAlt: 'Login QR code',
    scanScanned: 'Scanned',
    scanConfirmTip: 'Please confirm the login in the Zhijie App',
    scanRefresh: 'Refresh QR Code',
    scanCreating: 'Loading QR code...',
    scanLoadFailed: 'Failed to load QR code',
    scanExpired: 'QR code has expired',
    scanCancelled: 'QR code login was cancelled',

    rule: {
      tenantId: {
        required: 'Please enter your tenant ID',
      },
      username: {
        required: 'Please enter your account',
      },
      password: {
        required: 'Please enter your password',
        length: 'Password must be between {min} and {max} characters long',
      },
      phoneNumber: {
        required: 'Please enter your phone number',
      },
      code: {
        required: 'Please enter the verification code',
      },
    },
    social: {
      wechat: 'WeChat',
      maxkey: 'MaxKey',
      topiam: 'TopIam',
      gitee: 'Gitee',
      github: 'GitHub',
    },
  },
  // 注册页面国际化
  register: {
    selectPlaceholder: '请选择/输入公司名称',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    register: '注 册',
    registering: '注 册 中...',
    registerSuccess: '恭喜你，您的账号 {username} 注册成功！',
    code: '验证码',
    switchLoginPage: '使用已有账户登录',
    rule: {
      tenantId: {
        required: '请输入您的租户编号',
      },
      username: {
        required: '请输入您的账号',
        length: '用户账号长度必须介于 {min} 和 {max} 之间',
      },
      password: {
        required: '请输入您的密码',
        length: '用户密码长度必须介于 {min} 和 {max} 之间',
        pattern: '不能包含非法字符：{strings}',
      },
      code: {
        required: '请输入验证码',
      },
      confirmPassword: {
        required: '请再次输入您的密码',
        equalToPassword: '两次输入的密码不一致',
      },
    },
  },

  // 导航栏国际化
  navbar: {
    full: '全屏',
    expor: '下载中心',
    muneout: '收起导航',
    munesut: '展开导航',
    language: '语言',
    dashboard: '首页',
    document: '项目文档',
    message: '通知',
    layoutSize: '布局大小',
    selectTenant: '选择租户',
    layoutSetting: '布局设置',
    version: '版本',
    updata: '更新',
    admin: '账号',
    personalCenter: '个人中心',
    logout: '退出登录',
    SwitchStores: '切换门店',
  },
  // 下载组件提示
  expor: {
    applyTime: '申请时间',
    applyName: '申请人',
    remark: '备注',
    remarkPla: '请输入备注！',
    status1: '数据准备完成',
    status2: '数据准备中,请稍等',
    status3: '数据导出失败',
    search: '请输入文件名称搜索',
    title1: '导出百万级数据等待实际较长（平均等待1小时），建议次日查询',
    title2: '下载中心仅保留一周内的准备数据，请及时下载所需数据',
  },

  // 个人中心
  PersonalCenter: {
    ChangePassword: '修改密码',
    PersonalInformation: '个人信息',
    BasicInformation: '基础资料',
    Username: '用户名称',
    Phone: '手机号码',
    Email: '用户邮箱',
    Department: '所属部门',
    AffiliatedRole: '所属角色',
    CreationDate: '创建日期',
    OldPassword: '旧密码',
    NewPassword: '新密码',
    Gender: '性别',
    ConfirmPassword: '确认密码',
    message_1: '两次输入的密码不一致',
    message_2: '旧密码不能为空',
    message_3: '新密码不能为空',
    message_4: '用户昵称不能为空',
    message_5: '不能包含非法字符：< > " \' \\ |',
    message_6: '确认密码不能为空',
  },
};
